<template>
    <svg height="96" viewBox="0 0 96 96" width="96" xmlns="http://www.w3.org/2000/svg">
        <!-- @vue-ignore -->
        <g fill="none" fill-rule="evenodd" transform="translate(-306 -398)">
            <path d="m306 398h96v96h-96z" opacity="0" />
            <!-- @vue-ignore -->
            <g stroke="currentColor" stroke-width="2">
                <path
                    d="m354 426.111111c6.16186 0 11.74581 2.223445 15.795395 5.792282 4.028079 3.549884 6.537938 8.435305 6.537938 13.771025 0 2.845393-1.47045 6.672329-4.309322 11.499034l1.17004 7.985871-8.301278-1.745994c-4.608571 1.638233-8.238042 2.47556-10.892773 2.47556-6.10894 0-11.647004-2.344182-15.684654-6.015179-4.092496-3.720864-6.648679-8.809769-6.648679-14.199292 0-5.33572 2.509859-10.221141 6.537938-13.771025 4.049585-3.568837 9.633535-5.792282 15.795395-5.792282z"
                    transform="matrix(-1 0 0 1 708 0)"
                />
                <circle cx="354" cy="446" r="39" />
            </g>
        </g>
    </svg>
</template>
